import { render, staticRenderFns } from "./AsterikaScreens.vue?vue&type=template&id=b2667dde&scoped=true"
import script from "./AsterikaScreens.vue?vue&type=script&lang=js"
export * from "./AsterikaScreens.vue?vue&type=script&lang=js"
import style0 from "./AsterikaScreens.vue?vue&type=style&index=0&id=b2667dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2667dde",
  null
  
)

export default component.exports